import { Tag, Text } from '@chakra-ui/react';
import { format } from 'date-fns';
import React from 'react';

import { TypeUtils } from '../../../../../../../framework/utils/UtilityTypes';
import { useGlobalStateMachine } from '../../../../../../GlobalStore';
import { AssignedDailyMatterSummary } from '../../../../../../models/gen/assignedDailyMatterSummary';
import { MasterKey } from '../../../../../../models/gen/masterKey';
import { UserSummary } from '../../../../../../models/gen/userSummary';
import { Formatter } from '../../../../../../utils/FormatUtils';
import { useMasterContext } from '../../../../../MasterProvider';

/**
 * 就業内容エリアプロパティ
 */
export type WorkContentAreaProps = {
  /**
   * 職人手配現場サマリ
   */
  dailyMatterSummary?: AssignedDailyMatterSummary;
  /**
   * 外注メンバサマリリスト
   */
  outsourcerMembers?: Array<UserSummary>;
};

/**
 * 就業内容エリア
 * @param props - プロパティ
 * @returns JSX要素
 */
const WorkContentArea: React.FunctionComponent<WorkContentAreaProps> = ({
  dailyMatterSummary = {},
  ...props
}) => {
  const { state } = useGlobalStateMachine();
  const {
    beLate,
    extraFeeIds,
    leaveWork,
    taskIds,
    userCodeWorker,
    workDateFrom,
    workDateTo,
  } = dailyMatterSummary;
  const master = useMasterContext();

  return (
    <>
      <Text
        key="worker"
        hidden={TypeUtils.isNilString(state.userInfo?.outsourcer_code)}
      >
        {TypeUtils.isNilString(userCodeWorker)
          ? '未アサイン'
          : props.outsourcerMembers?.find(
              (member) => member.userCode === userCodeWorker
            )?.name}
      </Text>
      <Text
        key="worktime"
        hidden={
          TypeUtils.isNilString(workDateFrom) ||
          TypeUtils.isNilString(workDateTo)
        }
        minWidth={{ base: '57px', md: '92px' }}
      >
        {workDateFrom && format(Formatter.createDate(workDateFrom), 'HH:mm')} -{' '}
        {workDateTo && format(Formatter.createDate(workDateTo), 'HH:mm')}
      </Text>
      <Text hidden={TypeUtils.isNil(taskIds)} key="workcontent">
        {taskIds?.map((taskId, idx) => (
          <Tag key={idx}>
            {master.getBy(MasterKey.Tasks, taskId)?.shortName}
          </Tag>
        ))}
      </Text>
      <Text
        hidden={
          TypeUtils.isNil(extraFeeIds) ||
          (TypeUtils.isNilNumber(master.role.se?.id)
            ? state.userInfo?.role_id.includes(master.role.se!.id!)
            : false)
        }
        key="point"
      >
        {extraFeeIds
          ?.map(
            (extraFeeId) =>
              master.getBy(MasterKey.ExtraFees, extraFeeId)?.shortName
          )
          .join(' ')}
      </Text>
      <Text key="remarks">
        {[
          // props.dailyMatter?.remarks,
          beLate ? '遅刻' : undefined,
          leaveWork ? '早退' : undefined,
        ].join(' ')}
      </Text>
    </>
  );
};

export default WorkContentArea;
